module.exports = __webpack_public_path__ + "static/media/icon-people.d004d474.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/assets/icon-people.svg
// module id = 766
// module chunks = 20